// Components
import { ButtonBase, Stack, Typography } from "@mui/material";

const SearchCard = ({ icon, title, description, borderColor, onClick }) => (
  <ButtonBase
    aria-label={title}
    onClick={onClick}
    sx={{
      flex: 1,
      border: "1px solid",
      borderColor,
      p: 2,
      transition: "transform 160ms ease, box-shadow 160ms ease",
      "&:hover": { transform: "translateY(-2px)", boxShadow: 3 },
    }}
  >
    <Stack spacing={{ xs: 3, sm: 6 }}>
      <Stack direction="row" spacing={1} justifyContent="flex-start">
        {icon}
        <Typography variant="h5" textAlign="left">
          {title}
        </Typography>
      </Stack>
      <Typography variant="body2" color="textSecondary" textAlign="left">
        {description}
      </Typography>
    </Stack>
  </ButtonBase>
);

export default SearchCard;
